<template>
  <div class="service-short-alarm">
    <p>
      {{ $t('messages.alarms.serviceShortAlarm.description') }}
    </p>

    <alarm-status
      :alarm="alarm"
      :alarm-active="computedAlarmIsActive"
    />

    <!-- active -->
    <slot v-if="computedAlarmIsActive">
      <!-- <p>{{ $t('messages.alarms.serviceShortAlarm.descriptionActive') }}</p>

      <h3
        class="g-text g-text--center"
      >
        {{ $t('messages.alarms.suggestion') }}
      </h3>

      <p>{{ $t('messages.alarms.serviceShortAlarm.descriptionActiveSuggestion') }}</p>
      <p>{{ $t('messages.alarms.serviceShortAlarm.descriptionActiveSuggestionQuestion') }}</p>

      <div class="g-alarm-handler__row g-alarm-handler__buttons g-text g-text--center">
        <button
          class="g-btn g-btn--rounded g-btn--blue"
          @click.stop="suggestedFixWorked = true"
        >
          {{ $t('messages.sharedTexts.controls.yes') }}
        </button>
        <button
          class="g-btn g-btn--rounded g-btn--blue"
          @click.stop="suggestedFixWorked = false"
        >
          {{ $t('messages.sharedTexts.controls.no') }}
        </button>
      </div> -->
      <div
        v-if="suggestedFixWorked === true"
        class="g-alarm-handler__row"
      >
        <!-- <h3 class="g-text g-text--center">
          {{ $t('messages.alarms.suggestion') }}
        </h3>
        <p>{{ $t('messages.alarms.serviceShortAlarm.suggestedWorkedSuggestion') }}</p>
        <a href="#">
          {{ $t('messages.alarms.serviceShortAlarm.clampMeterhelp') }}
        </a> -->
        <h4>{{ $t('messages.alarms.serviceShortAlarm.powerStatus') }}</h4>
        <ul>
          <li>
            <div class="grid">
              <voltage-gauge :voltage = "store.getData('voltage')" />
              <current-gauge :current = "store.getData('current')" />
            </div>
          </li>
        </ul>
      </div>
      <div
        v-if="suggestedFixWorked === false"
        class="g-alarm-handler__row"
      >
        <h3 class="g-text g-text--center">
          {{ $t('messages.alarms.suggestion') }}
        </h3>
        <p>{{ $t('messages.alarms.serviceShortAlarm.suggestionFailedSuggestion') }}</p>
      </div>
    </slot>
    <!-- inactive -->
    <slot v-else>
      <p>{{ $t('messages.alarms.serviceShortAlarm.suggestionPassive') }}</p>

      <small>{{ $t('messages.alarms.serviceShortAlarm.suggestionPassiveDescription') }}</small>

      <alert-handler-list
        class="g-alarm-handler__row"
        :list="alarmData.list"
      />

      <hr>

      <!-- <div class="g-alarm-handler__row">
        <h3 class="g-text g-text--center">
          {{ $t('messages.alarms.suggestion') }}
        </h3>

        <p>{{ $t('messages.alarms.serviceShortAlarm.suggestionPassiveSuggestion') }}</p>

        <small>{{ $t('messages.alarms.serviceShortAlarm.suggestionPassiveSuggestionDescription') }}</small>

        <div class="g-alarm-handler__row g-text g-text--center">
          <div class="g-text g-text--center">
            <selective-survey-button :list="alarmData.list" />
          </div>
        </div>
      </div> -->
    </slot>
  </div>
</template>

<script>
import {ServiceAlarm} from '@/assets/javascript/mixins/ServiceAlarm'
import CurrentGauge from '@/components/CurrentGauge'
import VoltageGauge from '@/components/VoltageGauge'
// import ServiceSelectiveSurveyButton from '@/components/elements/ServiceSelectiveSurveyButton'

export default {
  name: 'ServiceShortAlarm',
  components: {
    'voltage-gauge': VoltageGauge,
    'current-gauge': CurrentGauge,
    // 'selective-survey-button': ServiceSelectiveSurveyButton
  },
  mixins: [ServiceAlarm],
  data() {
    return {
      suggestedFixWorked: null
    }
  }
}
</script>